import { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { setNavigate } from './services/api';
import Login from './components/Login/Login';
import Main from './components/Main/Main';
import Admin from './components/Admin/Admin';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

export default function App() {
  const navigate = useNavigate();
  const loggedIn = useSelector((s) => s.authentication.loggedIn);

  useEffect(() => {
    setNavigate(navigate);
    navigate('/main');
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/main" element={<Main />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </div>
  );
}
